// TODO: Create separate serializer for each model and validate data from storage in deserialiation
// There is no validation, it just serializes and deserializes data
export class BasicStorageSerializer {
    serializeForStorage(obj) {
        return JSON.stringify(obj);
    }
    deserializeFromStorage(stringValue) {
        try {
            const data = JSON.parse(stringValue);
            this.assertValid(data);
            return data;
        }
        catch (error) {
            // TODO: inject Sentry to not crash the tests
            // Sentry.logError(error);
            return null;
        }
    }
    // TODO: make it better (e.g. with zod?)
    assertValid(data) {
        if (data === null) {
            throw new Error("Invalid data");
        }
    }
}
